"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.futuresContractDetailsReducer = void 0;
var _actions = require("../actions");
var _futuresLevel1Actions = require("../actions/futuresLevel1Actions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  fetching: true,
  contractDetails: {}
};
var futuresContractDetailsReducer = exports.futuresContractDetailsReducer = function futuresContractDetailsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _actions.REQUEST_FUTURES_CONTRACT_DETAILS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          fetching: true
        });
      }
    case _actions.RECEIVE_FUTURES_CONTRACT_DETAILS:
      {
        return {
          contractDetails: payload,
          fetching: false
        };
      }
    case _futuresLevel1Actions.FUTURES_LEVEL1_LOADED:
      {
        return {
          contractDetails: _objectSpread(_objectSpread({}, state.contractDetails), {}, {
            IndexPrice: payload.level1Data.IndexPrice,
            MarkPrice: payload.level1Data.MarkPrice,
            OpenInterest: payload.level1Data.OpenInterest,
            VolumeP1: payload.level1Data.Volume,
            VolumeP2: payload.level1Data.TurnoverVolume
          }),
          fetching: false
        };
      }
    default:
      return state;
  }
};